import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../LanguageContext";
import backgroundImage from "../assets/home_background.png";
import "../styles/Home.css";

const Home = () => {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    // Home 진입 시 스크롤 막기
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="home-wrapper">
      <div className="home-hero">
        <img src={backgroundImage} alt="hero" className="hero-image" />
        <div className="hero-text">
          <h1>
            {language === "ko"
              ? "임신율 예측 자가 테스트"
              : "Testing fertility prediction in fertile patients"}
          </h1>
          <p>
            {language === "ko"
              ? "Testing fertility prediction in fertile patients"
              : "임신율 예측 자가 테스트"}
          </p>
          <button onClick={() => navigate("/survey")}>
            {language === "ko" ? "테스트 시작하기" : "Start Test"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
